const state = {
    active : 1,
}
const mutations = {
    'SET_DEFAULT' ( state ) {
        state.active = 0;
    },
    'SET_STATUS' ( state, {status} ) {
          $jQuery('body').removeClass('popup');
        if(status){
             $jQuery('body').addClass('popup');
        }
        state.active = status;
    }
};
const actions = {
    initDefault : ( {commit} ) => {
        commit( 'SET_DEFAULT' );
    },
    setStatus   : ( {commit}, params ) => {
        commit( 'SET_STATUS', params );
    }
};
const getters = {
    isActive : state => {
        return state.active;
    }
}
export default {
    state,
    mutations,
    actions,
    getters
}


// WEBPACK FOOTER //
// ./src/store/modules/crosselings.js